var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.353 2.84 7.264 14.897c.519.876 1.383 1.578 2.421 1.753l16.256 2.453c2.594.35 3.632 3.68 1.73 5.609l-11.76 11.567c-.692.7-1.038 1.752-.865 2.804l2.767 16.299c.519 2.629-2.248 4.732-4.67 3.33L33.97 53.84c-.865-.525-2.075-.525-2.94 0l-14.527 7.712c-2.42 1.227-5.015-.701-4.67-3.33l2.768-16.3c.173-1.05-.173-2.102-.865-2.803L1.976 27.552c-1.902-1.928-.864-5.083 1.73-5.609l16.256-2.453c1.038-.175 1.902-.877 2.421-1.753L29.647 2.84c1.037-2.453 4.496-2.453 5.706 0z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.023
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar10);
export default __webpack_public_path__ + "static/media/star10.92d96192.svg";
export { ForwardRef as ReactComponent };